// src/components/Workout/ReplacementModal.js
import React, { useContext } from "react";
import LanguageContext from "../../../context/LanguageContext";

// point at the same JSON files…
import jsonDataEn from "./data/data-en.json";
import jsonDataFr from "./data/data-fr.json";

const exerciseDataEn = require("../../data/data-en.json");
const exerciseDataFr = require("../../data/data-fr.json");

const ReplacementModal = ({ exercise, index, selectedReplacement, handleReplacementChange, handleReplaceSubmit }) => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;
  const exerciseData = language === "en" ? exerciseDataEn.data : exerciseDataFr.data;

  // Filter out any falsy entries (null/undefined)
  const validReplacements = Array.isArray(exercise.replacement) ? exercise.replacement.filter(Boolean) : [];

  return (
    <div className="modal fade" id={`modal-${index}`} tabIndex="-1" aria-labelledby={`modalLabel-${index}`} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content bg-dark">
          <div className="modal-header" style={{ alignItems: "center" }}>
            <div
              className="header-text"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title text-color" id={`modalLabel-${index}`}>
                {data.altTitle}
              </h5>
              <p className="text-start" style={{ color: "#ccc", marginTop: "0.5rem" }}>
                {data.altDescl1} <br /> {data.altDescl2}
              </p>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div className="modal-body">
            <form>
              {validReplacements.length > 0 ? (
                validReplacements.map((altExercise, altIndex) => {
                  // locale-aware fields for this replacement option
                  const displayName = language === "en" ? altExercise.name : altExercise.name_fr;
                  const primaryMuscle = language === "en" ? altExercise.primary_muscle : altExercise.primary_muscle_fr;
                  const secondaryMuscle = language === "en" ? altExercise.secondary_muscle : altExercise.secondary_muscle_fr;
                  const tertiaryMuscle = language === "en" ? altExercise.tertiary_muscle : altExercise.tertiary_muscle_fr;

                  return (
                    <div key={altExercise.exercise_id || altIndex} className="form-check d-flex align-items-center mb-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name={`replacementRadios-${index}`}
                        id={`replacementRadios-${index}-${altIndex}`}
                        value={displayName}
                        onChange={() => handleReplacementChange(index, altIndex)}
                        style={{
                          marginTop: 0,
                          marginRight: "16px",
                          alignSelf: "center",
                        }}
                      />
                      <label className="form-check-label w-100" htmlFor={`replacementRadios-${index}-${altIndex}`}>
                        <div className="exercise-container-modal d-flex">
                          <div style={{ flexGrow: 1, textAlign: "left" }}>
                            <div className="row">
                              <div className="col-4 d-flex justify-content-center align-items-center">
                                <div className="gif-container">
                                  <img src={`assets/exercise-gif/${altExercise.name}.gif`} className="img-fluid" alt={`${displayName} Exercise Animation`} />
                                </div>
                              </div>

                              <div className="col-8">
                                <h5 className="text-start mb-2">{displayName}</h5>
                                <hr className="red-divider" />
                                <div>
                                  {altExercise.tempo && (
                                    <p className="mb-1">
                                      <strong>Tempo:</strong> {altExercise.tempo}
                                    </p>
                                  )}
                                  {altExercise.Sets && (
                                    <p className="mb-1">
                                      <strong>{exerciseData.workout.sets}</strong> {altExercise.Sets}
                                    </p>
                                  )}
                                  {altExercise.Reps && (
                                    <p className="mb-1">
                                      <strong>{altExercise.Reps.endsWith("min") ? `${exerciseData.workout.duration}:` : `${exerciseData.workout.reps}:`}</strong> {altExercise.Reps}
                                    </p>
                                  )}
                                  {altExercise.Rest && altExercise.Rest !== "N/A" && (
                                    <p className="mb-1">
                                      <strong>{exerciseData.workout.rest}:</strong> {altExercise.Rest}
                                    </p>
                                  )}
                                </div>

                                <div className="mt-2">
                                  {primaryMuscle && <span className="muscles-badge badge-danger me-1">{primaryMuscle}</span>}
                                  {secondaryMuscle && <span className="muscles-badge badge-warning me-1">{secondaryMuscle}</span>}
                                  {tertiaryMuscle && <span className="muscles-badge badge-success">{tertiaryMuscle}</span>}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  );
                })
              ) : (
                <p className="text-center text-muted fs-5">{data.noReplacement}</p>
              )}
            </form>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {data.closeBtn}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={() => handleReplaceSubmit(index)}
              disabled={validReplacements.length === 0 || selectedReplacement === undefined}
            >
              {data.replaceBtn}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplacementModal;
